import { Component, OnInit, OnDestroy } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { SubscriptionLike } from 'rxjs';
import { ApidataRequestService } from 'src/app/services/apidata-request.service';
import { MsgInfo } from '../email-read/email-read.component';
import { serviceConstants } from 'src/app/constants/service.constants';
import { CommonService } from 'src/app/services/common.service';


@Component({
  selector: 'app-expand-email',
  templateUrl: './expand-email.component.html',
  styleUrls: ['./expand-email.component.scss']
})
export class ExpandEmailComponent implements OnInit, OnDestroy {
  subGetData: SubscriptionLike;
  subQueryParams: SubscriptionLike;

  messageID: any;
  MailData = new MsgInfo();
  MsgBodyForm: UntypedFormGroup
  toEmailsRem: string[] = []
  ccEmailsRem: string[] = []
  bccEmailsRem: string[] = []
  toEmail_1st: string = ""
  ccEmail_1st: string = ""
  bccEmail_1st: string = ""
  showTO: boolean = false;
  showCC: boolean = false;
  showBCC: boolean = false;
  showSubject: boolean = false;
  SubjectMore: boolean = false;

  editorInit: Record<string, any> | undefined = {
    base_url: '/tinymce', readonly: true,
    suffix: '.min',
    statusbar: false,
    toolbar: false,
    menubar: false,
    height: 'calc(100vh - 355px)  !important',
    paste_data_images: true
  };

  dateFormat = localStorage.getItem("_Dateformate") ?? 'DD MMM YYYY';
  datetimeFormat = this.dateFormat + ' ' + localStorage.getItem("_Timeformate");
  timeFormat: any = localStorage.getItem("_Timeformate");
  baseURL: string = "";
  constructor(
    public apiUrlservice: ApidataRequestService,
    private activatedRoute: ActivatedRoute,
    private commonService: CommonService
  ) { 
    this.baseURL = serviceConstants.baseUrl;
  }

  ngOnDestroy(): void {
    if (this.subGetData)
      this.subGetData.unsubscribe();
    if (this.subQueryParams)
      this.subQueryParams.unsubscribe();
  }
  ngOnInit(): void {

    this.subQueryParams = this.activatedRoute.queryParams.subscribe(x => {
      this.messageID = x.msgID.split(' ')[0];
      this.getMessage(this.messageID);
    });
    this.MsgBodyForm = new UntypedFormGroup({ msgBody: new UntypedFormControl("") });
  }

  ViewFile(fileID,fileName)
  {
  this.commonService.previewFile(fileID,fileName,"main"); 
  
  }
  
  downloadFile(ID) {
    let url = serviceConstants.apiURL + "api/ISTFileAttachments/Downloadfile?FileID=" + ID;
    window.open(url);  
  }

  showMore(type) {
    switch (type) {
      case 'TO':
        this.showTO = !this.showTO;
        break;
      case "CC":
        this.showCC = !this.showCC;
        break;
      case "BCC":
        this.showBCC = !this.showBCC;
        break;
        case "Subject":
          if(!this.SubjectMore)
          {
        this.showSubject = !this.showSubject;
        this.SubjectMore= true;
          }
          else 
          {
            this.showSubject = false;
            this.SubjectMore= false;
          }
        break;
      default:
        this.showTO = false;
        this.showCC = false;
        this.showBCC = false;
        this.showSubject =false;
        this.SubjectMore = false;
    }
  }

  getMessage(MessageID: any) {
    this.subGetData = this.apiUrlservice.getData("api/Correspondence/GetMailInfo?MsgID=" + MessageID).subscribe(result => {
      if (result.Status) {
        this.MailData = result.Data;
        setTimeout(() => {
          this.MsgBodyForm.controls["msgBody"].disable();
        }, 500);

        this.MsgBodyForm.controls["msgBody"].setValue(this.MailData.MsgBody);
        this.MailData.attNames = "";
        let fileNamesArray: string[] = [];
        this.MailData.Attachments.forEach(element => {
          fileNamesArray.push(element.FileName + element.FileExt);
        });
        this.MailData.attCount = fileNamesArray.length;
        this.MailData.attNames = fileNamesArray.join(', ');
        this.toEmailsRem = this.MailData.To.split(',');
        this.ccEmailsRem = this.MailData.CC.split(',');
        this.bccEmailsRem = this.MailData.BCC.split(',');
        this.toEmail_1st = this.toEmailsRem[0];
        this.ccEmail_1st = this.ccEmailsRem[0];
        this.bccEmail_1st = this.bccEmailsRem[0];
        this.toEmailsRem.splice(this.toEmailsRem.indexOf(this.toEmail_1st), 1);
        this.ccEmailsRem.splice(this.ccEmailsRem.indexOf(this.ccEmail_1st), 1);
        this.bccEmailsRem.splice(this.bccEmailsRem.indexOf(this.bccEmail_1st), 1);
      } else {
        this.MailData = new MsgInfo();
        this.toEmailsRem = [];
        this.ccEmailsRem = [];
        this.bccEmailsRem = [];
      }
    });
  }


}
